"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Pagination = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactPaginate = _interopRequireDefault(require("react-paginate"));

require("./styles.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Pagination =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Pagination, _React$Component);

  function Pagination() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Pagination);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Pagination)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "props", void 0);

    _defineProperty(_assertThisInitialized(_this), "renderLabel", function () {
      return _react.default.createElement("span", {
        className: "pagination-component__label"
      }, "".concat(_this.props.currentPage, " of ").concat(_this.props.pageCount));
    });

    return _this;
  }

  _createClass(Pagination, [{
    key: "render",
    value: function render() {
      var hidePages = false;

      if (this.props.pageRangeDisplayed === 1) {
        hidePages = true;
      }

      return _react.default.createElement("div", {
        className: "pagination"
      }, this.props.showLabel ? this.renderLabel() : null, _react.default.createElement(_reactPaginate.default, {
        forcePage: parseInt(this.props.currentPage, 10) - 1,
        pageCount: this.props.pageCount,
        pageRangeDisplayed: this.props.pageRangeDisplayed,
        marginPagesDisplayed: this.props.marginPagesDisplayed,
        onPageChange: this.props.onPageChange,
        containerClassName: "pagination-component ".concat(hidePages ? '' : 'pagination-horizontal'),
        previousLabel: '',
        previousClassName: 'pagination-component__prev',
        previousLinkClassName: 'pagination-component__prev--link',
        nextLabel: '',
        nextLinkClassName: 'pagination-component__next--link',
        nextClassName: 'pagination-component__next',
        breakLabel: _react.default.createElement("a", null, " ... "),
        breakClassName: "".concat(this.props.showElipsis ? 'pagination-component--elipsis' : 'pagination-component--hide'),
        pageClassName: "".concat(hidePages ? 'pagination-component--hide' : 'pagination-component__page'),
        pageLinkClassName: "".concat(hidePages ? 'pagination-component--hide' : 'pagination-component__page--link')
      }));
    }
  }]);

  return Pagination;
}(_react.default.Component);

exports.Pagination = Pagination;

_defineProperty(Pagination, "defaultProps", {
  showLabel: true,
  showElipsis: false
});

var _default = Pagination;
exports.default = _default;